import React, {FunctionComponent, useState} from "react";
import {Button, Header, Icon, Modal, TransitionablePortal, Segment, Message} from "semantic-ui-react";

interface DeleteDialogProps{
    id:         string
    label:      string
    uri:        string
    onClose:    (update: boolean) => void
}

const DeleteDialog: FunctionComponent<DeleteDialogProps> = ({id,label, uri, onClose}) => {

    const [error, setError] = useState("");

    return <Modal
        open
        basic
        size='tiny'
        onClose={_ => onClose(false)}
    >
        <TransitionablePortal onClose={_ => onClose(true)} open={!!error}>
            <Segment
                style={{ position: 'absolute', left: '20%',  top: '30%', width: '60%', minHeight: '40%', zIndex: 1000 }}
            >
                <Header icon='ban' content='This operation disable the database'/>
                <p>Most likely, this image is installed on one of the existing disks or is the base one.</p>
                <p>Details are in the message from the data</p>
                <Message negative style={{ height: '100%'}}>
                    <Message.Header>Error description:</Message.Header>
                    <p>{error}</p>
                </Message>
                <Button
                    floated='right'
                    color='red'
                    onClick={_ => onClose(true)}
                    style={{ position: 'absolute', bottom: '10px',  right: '10px'}}
                >
                    <Icon name='close' /> Close
                </Button>
            </Segment>
        </TransitionablePortal>

        <Header icon='trash alternate outline' content={`Delete ${uri}`} />
        <Modal.Content>
            <p>
                {`Are you sure you want to delete "${label}"?`}
            </p>
        </Modal.Content>
        <Modal.Actions>
            <Button basic color='green' inverted onClick={(e: React.MouseEvent) => {
                fetch(`./${uri}/${id}`, {
                    method: "DELETE"
                })
                    .then(res => {
                            res.ok
                                ? onClose(true)
                                : res.text().then(text => setError(text))
                        }
                    )
            }}>
                <Icon name='checkmark' /> Yes
            </Button>
            <Button  color='red' inverted onClick={(e: React.MouseEvent) => onClose(false)}>
                <Icon name='remove' /> No
            </Button>
        </Modal.Actions>
    </Modal>
}

export default DeleteDialog;